<template>
    <v-container>

        <GeoLocation :sites="getSites" v-if="isSuccess === null" @snack="snack" @result="result"></GeoLocation>
        <v-card v-if="isSuccess">
            <v-card-title>Checked In Successfully</v-card-title>
            <v-card-text align="center">
                <v-icon color="var(--darkSecondColor)" size="72">mdi-check-circle</v-icon>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click="goToHome" class="float-right" :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Home</v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="isSuccess === false">
            <v-card-title>Check-In Failed</v-card-title>
            <v-card-text align="center">
                <v-icon color="red" size="72">mdi-close-circle</v-icon>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click="success = null" class="float-right" :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Try Again</v-btn>
            </v-card-actions>
        </v-card>

    </v-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import GeoLocation from '@/components/GeoLocation.vue';
import accessHelper from '@/mixins/accessHelper';
export default {
    name: "CheckInPage",

    props: {
    },
    mixins: [accessHelper],
    components: {
        GeoLocation
    },
    data: () => ({
        sites: [],
        isSuccess: null,
    }),
    computed: mapGetters([
        "getAccount",
        "getSites",
    ]),
    mounted(){
        this.fetchSites();
    },
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'fetchSites'
        ]),

        result(isSuccessful) {
            if (isSuccessful)
                this.isSuccess = true;
            else
                this.isSuccess = false;
        },
        goToHome() {
            this.$router.push({ path: '/' });
        },
        snack(msg){
            this.$emit('snack', msg);
        }
    },
}
</script>

<style scoped>
</style>